import { CircleCheck, Plus, Trash2 } from "lucide-react";
import React from "react";

interface SingleSkill {
	added: boolean;
	skill: string;
}

interface SingleSkillItemProps {
	onSelectSingleSkill: (groupedSkillIndex: number, singleSkillIndex: number) => void;
	singleSkill: SingleSkill;
	groupedSkillIndex: number;
	singleSkillIndex: number;
}

function SingleSkillItem({
	onSelectSingleSkill,
	singleSkill,
	groupedSkillIndex,
	singleSkillIndex,
}: SingleSkillItemProps) {
	const [isHovered, setIsHovered] = React.useState(false);

	return (
		<div
			className="box-border flex h-[38px] w-[150px] cursor-pointer items-center justify-between gap-3 rounded-[5px] border border-black/[0.18] border-dashed px-3 py-[9px]"
			onMouseEnter={() => setIsHovered(true)}
			onMouseLeave={() => setIsHovered(false)}
			onClick={() => onSelectSingleSkill(groupedSkillIndex, singleSkillIndex)}
		>
			<div className="min-w-0 flex-1 truncate text-[#161616] text-sm">{singleSkill.skill}</div>
			{singleSkill.added &&
				(isHovered ? (
					<Trash2 className="size-4 shrink-0 text-red-600" />
				) : (
					<CircleCheck className="size-4 shrink-0 fill-success-default stroke-white" />
				))}
			{!singleSkill.added && (
				<Plus
					className="size-4 shrink-0 cursor-pointer"
					onClick={() => onSelectSingleSkill(groupedSkillIndex, singleSkillIndex)}
				/>
			)}
		</div>
	);
}

export default SingleSkillItem;
